/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import React, { useState, useEffect } from 'react';
import StockChart from "../../components/chartgraphique/StockChart/index.js";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getMarches, getDataForCurrentMinutes, postAchat, postVente } from '../../Api/authApi.js.js';
import { useLocation } from 'react-router-dom';
import Loader from "../../components/Loader/index.js";
import './portefeuilledetail.css';

const PorteFeuilleDetail = () => {
  const location = useLocation();
  const segments = location.pathname.split('/');
  const marchesid = segments[2];
  const leagueid = segments[3];

  const [selectedMarche, setSelectedMarche] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userId = useSelector((state) => state.auth.user.id);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMarketDetails = async () => {
      try {
        setLoading(true);

        if (!marchesid || !leagueid) {
          setError("Paramètres manquants dans l'URL.");
          return;
        }

        const data = await getMarches(userId);
        const market = data.find(
          (m) => m.marche_id === parseInt(marchesid) && m.league_id === parseInt(leagueid)
        );

        if (!market) {
          setError("Marché introuvable avec les paramètres fournis.");
          return;
        }

        const enrichedData = await getDataForCurrentMinutes(marchesid, leagueid);

        setSelectedMarche({
          ...market,
          current_value: enrichedData.value,
          last_value: enrichedData.last_value,
          difference: enrichedData.difference,
          heure_complete: enrichedData.hour,
        });
      } catch (err) {
        setError(err.message || "Une erreur s'est produite.");
        console.error("Erreur lors de la récupération des marchés :", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchMarketDetails();
    }
  }, [userId, marchesid, leagueid]);

  const handleAchat = async () => {
    if (!selectedMarche) return;
    const { marche_id, titre, icon, type, league_id, current_value, heure_complete, difference } = selectedMarche;
    try {
      const value = parseFloat(current_value).toFixed(2);
      await postAchat(userId, marche_id, value, type, league_id);
      navigate('/portefeuille_achat', {
        state: { marche_id, titre, icon, value, heure_complete, difference, type, league_id },
      });
    } catch (error) {
      console.error("Erreur lors de l'achat :", error);
    }
  };

  const handleVente = async () => {
    if (!selectedMarche) return;
    const { marche_id, titre, icon, type, league_id, current_value, heure_complete, difference } = selectedMarche;
    try {
      const value = parseFloat(current_value).toFixed(2);
      await postVente(userId, marche_id, value, type, league_id);
      navigate('/portefeuille_vente', {
        state: { marche_id, titre, icon, value, heure_complete, difference, type, league_id },
      });
    } catch (error) {
      console.error("Erreur lors de la vente :", error);
    }
  };

  if (loading) {
    return (
      <div className="pd-page">
        <div className="pd-loader-wrap">
          <Loader size={56} />
        </div>
      </div>
    );
  }

  const diff = selectedMarche ? parseFloat(selectedMarche.difference) : 0;
  const isUp = diff >= 0;
  const currentVal = selectedMarche ? parseFloat(selectedMarche.current_value) : 0;
  const lastVal = selectedMarche ? parseFloat(selectedMarche.last_value) : 0;

  return (
    <div className="pd-page">
      {/* back + asset identity */}
      <div className="pd-header">
        <button
          className="pd-back-btn pill-tap"
          onClick={() => navigate(-1)}
          aria-label="Retour"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {selectedMarche && (
          <>
            <div className="pd-asset-icon">
              <img src={selectedMarche.icon} alt={selectedMarche.titre} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 15, fontWeight: 600, letterSpacing: '-0.01em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {selectedMarche.titre}
                </span>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text-mute)', marginTop: 1 }}>
                {selectedMarche.type}
              </div>
            </div>
          </>
        )}
      </div>

      {/* price */}
      {selectedMarche && (
        <div className="pd-price-row">
          <span className="pd-price num">
            {currentVal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            <span style={{ color: 'var(--text-dim)', fontWeight: 500, fontSize: 20 }}> €</span>
          </span>
          <span className={`pd-badge num ${isUp ? 'up' : 'down'}`}>
            {isUp ? '+' : ''}{diff.toFixed(2)} %
          </span>
          <span style={{ color: 'var(--text-mute)', fontSize: 11 }}>· {selectedMarche.heure_complete}</span>
        </div>
      )}

      {/* chart */}
      <div className="pd-chart-wrap relief">
        <StockChart marcheId={marchesid} leagueid={leagueid} />
      </div>

      {/* key stats */}
      {selectedMarche && (
        <div className="pd-stats">
          <div className="pd-stat">
            <span className="pd-stat-label">Actuel</span>
            <span className="pd-stat-value num">
              {currentVal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
            </span>
          </div>
          <div className="pd-stat">
            <span className="pd-stat-label">Précédent</span>
            <span className="pd-stat-value num">
              {lastVal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
            </span>
          </div>
          <div className="pd-stat">
            <span className="pd-stat-label">Variation</span>
            <span className="pd-stat-value num" style={{ color: isUp ? 'var(--up)' : 'var(--down)' }}>
              {isUp ? '+' : ''}{diff.toFixed(2)} %
            </span>
          </div>
        </div>
      )}

      {/* description */}
      {selectedMarche && selectedMarche.description && (
        <div className="pd-description relief">
          <div className="pd-description-label">À propos</div>
          <p className="pd-description-text">{selectedMarche.description}</p>
        </div>
      )}

      {/* CTA */}
      {selectedMarche && (
        <>
          <div className="pd-cta-row">
            <button className="pd-cta-btn buy pill-tap" onClick={handleAchat}>
              ACHETER
              <span className="sub">POSITION LONGUE</span>
            </button>
            <button className="pd-cta-btn sell pill-tap" onClick={handleVente}>
              VENDRE
              <span className="sub">POSITION COURTE</span>
            </button>
          </div>
          <div className="pd-disclaimer">Argent virtuel · simulation pédagogique</div>
        </>
      )}
    </div>
  );
};

export default PorteFeuilleDetail;
